import React from 'react';
import ReactDOM from 'react-dom/client';
import posthog from 'posthog-js';

// Suppress console logs in production
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.warn = () => {};
  console.debug = () => {};
}
import './index.css';
import './xy-theme.css';
import App from './App';

posthog.init('phc_6fij8bVxFivf4oyyeaFQTLFbbz3rOkTQeo7fUbZpmVU', {
  api_host: 'https://us.i.posthog.com',
  person_profiles: 'always',
  capture_pageview: true,
  capture_pageleave: true,
  disable_session_recording: false,
  session_recording: {
    maskAllInputs: false,
    maskTextSelector: null,
  },
  loaded: (posthog) => {
    // Tag local server usage vs production
    const isLocalServer = window.BONZAI_API && window.BONZAI_API.includes('localhost');
    posthog.register({
      is_local_server: isLocalServer,
      bonzai_repo: window.BONZAI_REPO || null,
      source: isLocalServer ? 'local_cli' : 'website'
    });
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

